import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7nt3s643r3: FaireBrandEntity = {
  token: "b_7nt3s643r3",
  type: "brand",
  name: "English Factory",
  avatarUrl:
    "https://cdn.faire.com/fastly/be89d985dcb1afd5ee365745c948023bbf08c70c40917aa2e195df9a1e541dfe.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4a1f55bd79230ceec689bab7c06846bbc975c06747b4f10d3233956f6420282a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/be89d985dcb1afd5ee365745c948023bbf08c70c40917aa2e195df9a1e541dfe.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4a1f55bd79230ceec689bab7c06846bbc975c06747b4f10d3233956f6420282a.jpeg",
  location: "LOS ANGELES, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 16,
  isInsider: true,
  description:
    "Founded in Los Angeles in 2014, English Factory emerged following the success of its sister label, Endless Rose—bringing with it a slightly more directional, subtly edgy point of view. While rooted in femininity, the brand leans into a modern, confident aesthetic that feels both elevated and unexpected. English Factory is defined by its balance of contrast: classic silhouettes reimagined with a twist. Feminine details are tempered with structure, airy cottons are paired with sharper lines, and bold colors meet clean, relaxed shapes. There’s an ease to every piece—but always with a sense of intention and individuality.\n\nVersatility remains at the heart of the brand. Designed to move seamlessly from day to night, each piece can be styled across occasions—layered, dressed up, or pared back. It’s a wardrobe built on adaptability, where statement and staple coexist.\n\nCreated for the modern woman who values both style and edge, English Factory offers collections that feel fresh, confident, and slightly unexpected—timeless at their core, but never predictable.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:42.093Z",
    importedBy: "entity-db-cli",
  },
};
